import { render, staticRenderFns } from "./TreeNodeAttributesControl.global.vue?vue&type=template&id=617ba8a8&lang=pug&"
import script from "./TreeNodeAttributesControl.global.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeAttributesControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports